import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoCreatorInfo,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {GameStageService} from "../../../serverService/gameService/GameStageService";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";

export default function GameStageBasicInfo({gameStageId}) {

    const [actionButtonLoading, setActionButtonLoading] = useState(false)
    const [gameStageTitle, setGameStageTitle] = useState("");
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [updatedBy, setUpdatedBy] = useState("");
    const [updatedAt, setUpdatedAt] = useState("");

    const gameStageService = new GameStageService();

    console.log("gameStageId", gameStageId)
    useEffect(() => {
        if (typeof gameStageService !== 'undefined') {
            getGameStageBasicInfoFromServer()
        }
    }, []);

    function getGameStageBasicInfoFromServer() {
        gameStageService.getGameStageInfo(gameStageId)
            .then(response => {
                setGameStageTitle(response.title)
                setCreatedBy(response.createdBy)
                setUpdatedAt(convertUniversalDateTimeToPersianDateTime(response.updatedAt))
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setUpdatedBy(response.updatedBy)
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })

    }

    function handleUpdateGameStageBasicInfo() {
        setActionButtonLoading(true)
        gameStageService.updateGameStageInfo(gameStageId, gameStageTitle)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonLoadingState={actionButtonLoading}
                    actionButtonOnclickWithValidation={handleUpdateGameStageBasicInfo}
                >
                    <RaikoGridOneColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"عنوان مرحله"}
                            value={gameStageTitle}
                            setValue={setGameStageTitle}
                            required
                        />
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
            <RaikoCreatorInfo
                title={"آخرین بروزرسانی"}
                createdByTitle={"ادمین"}
                createdBy={updatedBy}
                createdAtTitle={"تاریخ بروزرسانی"}
                createdAt={updatedAt}/>
        </RaikoGridOneColumn>
    )
}